import React from 'react';

const SkillsSection = () => {
  return (
    <section id="skills">
      <div className="container">
        <div className="section-label">02 — Skills</div>
        <div className="skills-grid reveal">
          <div className="skill-group">
            <div className="skill-group-title">Frontend</div>
            <div className="skill-tags">
              <span className="tag">React</span>
              <span className="tag">React Native</span>
              <span className="tag">jQuery</span>
              <span className="tag">Tailwind CSS</span>
              <span className="tag">Bootstrap CSS</span>
              <span className="tag">Ionic</span>
            </div>
          </div>
          <div className="skill-group">
            <div className="skill-group-title">Backend</div>
            <div className="skill-tags">
              <span className="tag">Ruby on Rails</span>
              <span className="tag">RSpec</span>
              <span className="tag">PHP</span>
              <span className="tag">CodeIgniter</span>
              <span className="tag">Node.js</span>
              <span className="tag">GraphQL</span>
            </div>
          </div>
          <div className="skill-group">
            <div className="skill-group-title">Infrastructure</div>
            <div className="skill-tags">
              <span className="tag">PostgreSQL</span>
              <span className="tag">MySQL</span>
              <span className="tag">Docker</span>
              <span className="tag">Git</span>
              <span className="tag">AWS</span>
              <span className="tag">Digital Ocean</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;

